const paginatorForm = document.getElementById('paginatorForm');
const paginatorFormPage = document.getElementById('paginatorFormPage');

if (paginatorForm && paginatorFormPage) {
    document.addEventListener('click', (e) => {
        if (e.target.matches('[data-page]')) {
            e.preventDefault();
            const page = e.target.dataset.page;
            paginatorFormPage.value = page;
            paginatorForm.submit();
        }
    });
}